import {FormikFieldConfig, FormikFieldTypes, ValidationErrorType} from 'palipali-panel-common-web';
import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';

export const vehicleInspectionFormConfig = (): FormikFieldConfig[] => {
    const {t} = useTranslation();
    return [
        {
            name: 'until',
            label: t('vehicles.vehicleOperation.inspection.form.until.label'),
            validation: Yup.date()
                .required(`${t(ValidationErrorType.IS_REQUIRED)}`)
                .min(new Date(), `${t('formValidation.errors.isProcessAtLaterThanNow')}`),
            startFromTomorrow: true,
            className: 'vehicle-inspection-form-until-form-control',
            type: FormikFieldTypes.DATE,
            dateFormat: 'dd.MM.yyyy',
        },
        {
            name: 'inspectionPhotoFront',
            label: t('vehicles.vehicleOperation.inspection.form.documentPhoto.labelFront'),
            validation: Yup.object()
                .shape({
                    name: Yup.string().required(`${t(ValidationErrorType.IS_REQUIRED)}`),
                    fileKey: Yup.string().required(`${t(ValidationErrorType.IS_REQUIRED)}`),
                    url: Yup.string().required(`${t(ValidationErrorType.IS_REQUIRED)}`),
                })
                .required(`${t(ValidationErrorType.IS_REQUIRED)}`),
            acceptedFileTypes: 'image/jpeg, image/png, application/pdf',
            multipleFiles: false,
            className: 'vehicles-view-vehicle-inspection-form-inspection-photo-front',
            placeholder: `${t('vehicles.vehicleOperation.inspection.form.documentPhoto.placeholderFront')}`,
            type: FormikFieldTypes.FILE,
        },
        {
            name: 'inspectionPhotoBack',
            label: t('vehicles.vehicleOperation.inspection.form.documentPhoto.labelBack'),
            validation: Yup.object()
                .shape({
                    name: Yup.string().required(`${t(ValidationErrorType.IS_REQUIRED)}`),
                    fileKey: Yup.string().required(`${t(ValidationErrorType.IS_REQUIRED)}`),
                    url: Yup.string().required(`${t(ValidationErrorType.IS_REQUIRED)}`),
                })
                .required(`${t(ValidationErrorType.IS_REQUIRED)}`),
            acceptedFileTypes: 'image/jpeg, image/png, application/pdf',
            multipleFiles: false,
            className: 'vehicles-view-vehicle-inspection-form-inspection-photo-back',
            placeholder: `${t('vehicles.vehicleOperation.inspection.form.documentPhoto.placeholderBack')}`,
            type: FormikFieldTypes.FILE,
        },
    ];
};
